import type { Components } from 'react-markdown'
import Markdown from 'react-markdown'
import gfm from 'remark-gfm'

import Image from './Image'
import Link from './Link'


const rehypePlugins = [gfm]
const components = { img: Image as unknown as Components['img'], a: Link as unknown as Components['a'] }

interface IProps {
  description: string,
}

export default function MarkdownDescription({
  description,
}: IProps): JSX.Element {
  return (
    <div className="markdown">
      <Markdown
        rehypePlugins={rehypePlugins}
        skipHtml={true}
        components={components}
      >
        {description}
      </Markdown>
    </div>
  )
}
